//front images dydis 700 ant 350 - apie 70 kb
import frontIMG from "../../assets/fashionFront/1_0002.jpg";
import front2IMG from "../../assets/fashionFront/1_0003.jpg";
import front3IMG from "../../assets/fashionFront/1_0004.jpg";
import front4IMG from "../../assets/fashionFront/1_0005.jpg";
import front5IMG from "../../assets/fashionFront/1_0006.jpg";
import front6IMG from "../../assets/fashionFront/1_0007.jpg";
import front7IMG from "../../assets/fashionFront/1_0008.jpg";
import front8IMG from "../../assets/fashionFront/1_0001.jpg";
import front9IMG from "../../assets/fashionFront/1_0009.jpg";
import front10IMG from "../../assets/fashionFront/1_0010.jpg";
import front11IMG from "../../assets/fashionFront/1_0011.jpg";
import front12IMG from "../../assets/fashionFront/1_0012.jpg";
//1 gallery
import front1 from "../../assets/gallery1/1.jpg";
import front2 from "../../assets/gallery1/2.jpg";
import front3 from "../../assets/gallery1/3.jpg";
import front4 from "../../assets/gallery1/4.jpg";
import front5 from "../../assets/gallery1/5.jpg";
//2 gallery
import gal22img1 from "../../assets/gallery2/0_0001.jpg";
import gal22img2 from "../../assets/gallery2/0_0002.jpg";
import gal22img3 from "../../assets/gallery2/0_0003.jpg";
import gal22img4 from "../../assets/gallery2/0_0004.jpg";
import gal22img5 from "../../assets/gallery2/0_0005.jpg";
import gal22img6 from "../../assets/gallery2/0_0006.jpg";
import gal22img7 from "../../assets/gallery2/0_0007.jpg";
import gal22img8 from "../../assets/gallery2/0_0008.jpg";
import gal22img9 from "../../assets/gallery2/0.jpg";
//3 gallery
import gal3img001 from "../../assets/gallery3/001.jpg";
import gal3img01 from "../../assets/gallery3/01.jpg";
import gal3img1 from "../../assets/gallery3/1.jpg";
import gal3img2 from "../../assets/gallery3/2.jpg";
import gal3img3 from "../../assets/gallery3/3.jpg";
import gal3img4 from "../../assets/gallery3/4.jpg";
import gal3img5 from "../../assets/gallery3/5.jpg";
import gal3img7 from "../../assets/gallery3/7.jpg";
//4 gallery
import gal4img1 from "../../assets/gallery4/1.jpg";
import gal4img2 from "../../assets/gallery4/2.jpg";
import gal4img3 from "../../assets/gallery4/3.jpg";
import gal4img4 from "../../assets/homepageIcon.jpg";
import gal4img5 from "../../assets/gallery4/5.jpg";
import gal4img6 from "../../assets/gallery4/6.jpg";
import gal4img7 from "../../assets/gallery4/7.jpg";
import gal4img8 from "../../assets/gallery4/8.jpg";
import gal4img9 from "../../assets/gallery4/9.jpg";
import gal4img10 from "../../assets/gallery4/10.jpg";
import gal4img11 from "../../assets/gallery4/11.jpg";
import gal4img12 from "../../assets/gallery4/12.jpg";
import gal4img13 from "../../assets/gallery4/13.jpg";
import gal4img14 from "../../assets/gallery4/14.jpg";
//5 gallery
import gal5img0 from "../../assets/gallery5/01.jpg";
import gal5img1 from "../../assets/gallery5/1.jpg";
import gal5img2 from "../../assets/gallery5/2.jpg";
import gal5img3 from "../../assets/gallery5/3.jpg";
import gal5img4 from "../../assets/gallery5/4.jpg";
import gal5img5 from "../../assets/gallery5/5.jpg";
import gal5img6 from "../../assets/gallery5/6.jpg";
import gal5img7 from "../../assets/gallery5/7.jpg";
import gal5img8 from "../../assets/gallery5/8.jpg";
import gal5img9 from "../../assets/gallery5/9.jpg";
import gal5img10 from "../../assets/gallery5/10.jpg";
import gal5img11 from "../../assets/gallery5/11.jpg";
//6 gallery
import gal6img01 from "../../assets/gallery6/01.jpg";
import gal6img1 from "../../assets/gallery6/1.jpg";
import gal6img2 from "../../assets/gallery6/2.jpg";
import gal6img3 from "../../assets/gallery6/3.jpg";
import gal6img4 from "../../assets/gallery6/4.jpg";
//7 gallery
import gal2img01 from "../../assets/gallery7/1.jpg";
import gal2img1 from "../../assets/gallery7/fashion_0001.jpg";
import gal2img2 from "../../assets/gallery7/fashion_0002.jpg";
import gal2img3 from "../../assets/gallery7/fashion_0003.jpg";
import gal2img4 from "../../assets/gallery7/fashion_0004.jpg";
import gal2img5 from "../../assets/gallery7/fashion_0005.jpg";
import gal2img7 from "../../assets/gallery7/fashion_0007.jpg";
import gal2img8 from "../../assets/gallery7/fashion_0008.jpg";
import gal2img9 from "../../assets/gallery7/fashion_0009.jpg";
import gal2img10 from "../../assets/gallery7/fashion_0010.jpg";
import gal2img11 from "../../assets/gallery7/fashion_0011.jpg";
import gal2img12 from "../../assets/gallery7/fashion_0012.jpg";
//8 gallery
import gal8img1 from "../../assets/gallery8/1.jpg";
import gal8img2 from "../../assets/gallery8/2.jpg";
import gal8img3 from "../../assets/gallery8/3.jpg";
import gal8img4 from "../../assets/gallery8/4.jpg";
import gal8img5 from "../../assets/gallery8/5.jpg";
import gal8img6 from "../../assets/gallery8/6.jpg";
import gal8img7 from "../../assets/gallery8/7.jpg";
import gal8img8 from "../../assets/gallery8/8.jpg";
import gal8img9 from "../../assets/gallery8/9.jpg";
import gal8img10 from "../../assets/gallery8/10.jpg";
import gal8img11 from "../../assets/gallery8/11.jpg";
import gal8img12 from "../../assets/gallery8/12.jpg";
import gal8img13 from "../../assets/gallery8/13.jpg";
import gal8img14 from "../../assets/gallery8/14.jpg";
import gal8img15 from "../../assets/gallery8/15.jpg";
//9 gallery
import gal9img01 from "../../assets/gallery9/01.jpg";
import gal9img1 from "../../assets/gallery9/1.jpg";
import gal9img2 from "../../assets/gallery9/2.jpg";
import gal9img3 from "../../assets/gallery9/3.jpg";
import gal9img4 from "../../assets/gallery9/4.jpg";
import gal9img6 from "../../assets/gallery9/6.jpg";
import gal9img7 from "../../assets/gallery9/7.jpg";
import gal9img8 from "../../assets/gallery9/8.jpg";
import gal9img9 from "../../assets/gallery9/9.jpg";
import gal9img10 from "../../assets/gallery9/10.jpg";
import gal9img11 from "../../assets/gallery9/11.jpg";
import gal9img12 from "../../assets/gallery9/12.jpg";
import gal9img13 from "../../assets/gallery9/13.jpg";
import gal9img14 from "../../assets/gallery9/14.jpg";
import gal9img15 from "../../assets/gallery9/15.jpg";
//10 gallery
import gal10img01 from "../../assets/gallery10/01.jpg";
import gal10img1 from "../../assets/gallery10/1.jpg";
import gal10img3 from "../../assets/gallery10/3.jpg";
import gal10img4 from "../../assets/gallery10/4.jpg";
import gal10img5 from "../../assets/gallery10/5.jpg";
import gal10img6 from "../../assets/gallery10/6.jpg";
import gal10img7 from "../../assets/gallery10/7.jpg";
import gal10img8 from "../../assets/gallery10/8.jpg";
import gal10img9 from "../../assets/gallery10/9.jpg";
import gal10img10 from "../../assets/gallery10/10.jpg";
import gal10img11 from "../../assets/gallery10/11.jpg";
import gal10img12 from "../../assets/gallery10/12.jpg";
//11 gallery
import gal11img01 from "../../assets/gallery11/01.jpg";
import gal11img1 from "../../assets/gallery11/1.jpg";
import gal11img2 from "../../assets/gallery11/2.jpg";
import gal11img3 from "../../assets/gallery11/3.jpg";
import gal11img4 from "../../assets/gallery11/4.jpg";
import gal11img6 from "../../assets/gallery11/6.jpg";
import gal11img7 from "../../assets/gallery11/7.jpg";
import gal11img8 from "../../assets/gallery11/8.jpg";
import gal11img9 from "../../assets/gallery11/9.jpg";
import gal11img10 from "../../assets/gallery11/10.jpg";
import gal11img11 from "../../assets/gallery11/11.jpg";
import gal11img12 from "../../assets/gallery11/12.jpg";
import gal11img13 from "../../assets/gallery11/13.jpg";
import gal11img14 from "../../assets/gallery11/14.jpg";
import gal11img15 from "../../assets/gallery11/15.jpg";
import gal11img16 from "../../assets/gallery11/16.jpg";
import gal11img17 from "../../assets/gallery11/17.jpg";
import gal11img18 from "../../assets/gallery11/18.jpg";
import gal11img19 from "../../assets/gallery11/19.jpg";
import gal11img20 from "../../assets/gallery11/20.jpg";
import gal11img21 from "../../assets/gallery11/21.jpg";
import gal11img22 from "../../assets/gallery11/22.jpg";
import gal11img23 from "../../assets/gallery11/23.jpg";
import gal11img24 from "../../assets/gallery11/24.jpg";
import gal11img25 from "../../assets/gallery11/25.jpg";
import gal11img26 from "../../assets/gallery11/26.jpg";
import gal11img28 from "../../assets/gallery11/28.jpg";
import gal11img29 from "../../assets/gallery11/29.jpg";
import gal11img30 from "../../assets/gallery11/30.jpg";
import gal11img31 from "../../assets/gallery11/31.jpg";
import gal11img32 from "../../assets/gallery11/32.jpg";
import gal11img33 from "../../assets/gallery11/33.jpg";
import gal11img34 from "../../assets/gallery11/34.jpg";
import gal11img35 from "../../assets/gallery11/35.jpg";
import gal11img36 from "../../assets/gallery11/36.jpg";
//12 gallery
import gal12img01 from "../../assets/gallery12/01.jpg";
import gal12img1 from "../../assets/gallery12/1.jpg";
import gal12img3 from "../../assets/gallery12/3.jpg";
import gal12img5 from "../../assets/gallery12/5.jpg";
import gal12img6 from "../../assets/gallery12/6.jpg";
import gal12img7 from "../../assets/gallery12/7.jpg";

const galleries = [
    { front: frontIMG,
      title: "Laime Magazine",
      gallery: [front1, front2, front3, front4, front5],
      id: 1,
    },
    { front: front2IMG,
      title: "Moteris Magazine",
      gallery: [gal22img8, gal22img2, gal22img1, gal22img3, gal22img4, gal22img9, gal22img5, gal22img6, gal22img7],
      id: 2
    },
    { front: front3IMG,
      title: "Moteris Magazine",
      gallery: [gal3img001, gal3img01, gal3img1, gal3img2, gal3img3, gal3img4, gal3img5, gal3img7],
      id: 3
    },
    { front: front4IMG,
      title: "Inspirazzi Magazine",
      gallery: [gal4img14, gal4img1, gal4img2, gal4img3, gal4img4, gal4img5, gal4img6, gal4img7, gal4img8, gal4img9, gal4img10, gal4img11, gal4img12, gal4img13],
      id: 4
    },
    { front: front5IMG,
      title: "Leffronte Magazine",
      gallery: [gal5img0, gal5img1, gal5img2, gal5img3, front5IMG, gal5img4, gal5img5, gal5img6, gal5img7, gal5img8, gal5img9, gal5img10, gal5img11],
      id: 5
    },
    { front: front6IMG,
      title: "L'Officiel Homme",
      gallery: [gal6img01, gal6img1, gal6img2, gal6img3, gal6img4],
      id: 6
    },
    { front: front7IMG,
      title: "L'Officiel",
      gallery: [gal2img01, gal2img1, gal2img2, gal2img3, gal2img4, gal2img5, gal2img7, gal2img8, gal2img9, gal2img10, gal2img11, gal2img12],
      id: 7
    },
    { front: front8IMG,
      title: "L'Officiel",
      gallery: [gal8img1, gal8img2, gal8img3, gal8img4, gal8img5, gal8img6, gal8img7, gal8img8, gal8img9, gal8img10, gal8img11, gal8img12, gal8img13, gal8img14, gal8img15],
      id: 8
    },
    { front: front9IMG,
      title: "L'Officiel",
      gallery: [gal9img01, gal9img2, gal9img3, gal9img4, gal9img1, gal9img6, gal9img7, gal9img8, gal9img9, gal9img10, gal9img11, gal9img12, gal9img13, gal9img14, gal9img15],
      id: 9
    },
    { front: front10IMG,
      title: "Moteris Magazine",
      gallery: [gal10img01, gal10img1, gal10img3, gal10img4, gal10img5, gal10img6, gal10img7, gal10img8, gal10img9, gal10img10, gal10img11, gal10img12],
      id: 10
    },
    { front: front11IMG,
      title: "Moteris Magazine",
      gallery: [gal11img01, gal11img1, gal11img2, gal11img3, gal11img4, gal11img6, gal11img7, gal11img8, gal11img9, gal11img10, gal11img11, gal11img12, gal11img13, gal11img14, gal11img15, gal11img16, gal11img17, gal11img18, gal11img19, gal11img20, gal11img21, gal11img22, gal11img23, gal11img24, gal11img25, gal11img26, gal11img28, gal11img29, gal11img30, gal11img31, gal11img32, gal11img33, gal11img34, gal11img35, gal11img36],
      id: 11
    },
    { front: front12IMG,
      title: "Moteris Magazine",
      gallery: [gal12img01, gal12img1, gal12img3, gal12img5, gal12img6, gal12img7],
      id: 12
    },
    ]

export default galleries;